function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/legend-eau-cours-intermittent");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/legend-eau-cours-intermittent",
  fill: "#4D88FF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.66666667,10 L9.66666667,20 L2,20 L2,10 L9.66666667,10 Z M19.0666667,10 L19.0666667,20 L11.4,20 L11.4,10 L19.0666667,10 Z M28,10 L28,20 L20.8,20 L20.8,10 L28,10 Z"
})));

const SvgIco30EauCoursIntermittent = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30EauCoursIntermittent, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-eauCoursIntermittent.a2258538.svg";
export { ForwardRef as ReactComponent };